import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TDR } from 'tdr-common';
import CTALink from '../../components/buttons/CTALink';
import ErrorIcon from '../../icons/error-grey.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { analytics, BOOKING_CONFIRMATION_FAILED } from '../../helpers/analytics';
import { useTranslation } from 'react-i18next';

type ConfirmationFailedProps = {
	sessionId: string;
	restaurantSlug: string;
};

export const ConfirmationFailed = ({ sessionId, restaurantSlug }: ConfirmationFailedProps) => {
	const location = useLocation();
	const { t } = useTranslation();

	const goBackHref = `/${restaurantSlug}/checkout/${sessionId}/policies`;
	const needHelpHref = `mailto:${TDR.SUPPORT_EMAIL}?subject=Need help with checkout sessionID: ${sessionId}`;

	useEffect(() => {
		analytics.track(BOOKING_CONFIRMATION_FAILED, {
			...location
		});
	}, []);

	return (
		<ResultPageLayout headerIcon={ErrorIcon}>
			<ResultPageLayout.Title>{t('titles.oops')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>{t('error_pages.confirmation_failed')}</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<CTALink text={t('actions.go_back')} to={goBackHref} reloadDocument={true} />
				<CTALink text={t('actions.get_help')} to={needHelpHref} variant='dark' />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};
